import { Component } from '@angular/core';
import { OroService } from '../oroservice';

@Component({
  selector: 'app-reporting',
  standalone: false,
  templateUrl: './reporting.component.html',
  styleUrl: './reporting.component.scss'
})
export class ReportingComponent {
  dateVon: Date | null = null;
  dateBis: Date | null = null;
  reportType: number = -1;

  constructor(public oroservice: OroService) { }

  public downloadReport() : void {
    switch (this.reportType) {
      case 0: // Dossiereinbringlichkeit
        this.oroservice.getReportDossiereinbringlichkeit(this.dateVon, this.dateBis).then((object) => {
            this.oroservice.openDialogMessage("Reporting.Feedback");
        }).catch((error: any) => {
                this.oroservice.openDialogMessage("ERROR :(");
            });
        break;
    }
  }

  public isDateVonFuture() : boolean {
    if (this.dateVon != null && this.dateVon > new Date()) {
      return true;
    }

    return false;
  }

  public isDateFuture(date: Date) : boolean {
    if (date && date > new Date()) {
      return true;
    }

    return false;
  }

  public canSubmit() : boolean {
    if (this.reportType < 0) {
      return false;
    }

    if(this.isDateFuture(this.dateVon) || this.isDateFuture(this.dateBis)) {
      return false;        
    }

    if (this.dateVon && this.dateBis) {
      return this.dateBis >= this.dateVon;
    }    

    return true;
  }
}
